angular.module('impactx.sapconfig').controller('MaterialNumberCreationCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'id',
    MaterialNumberCreationCtrl]);

function MaterialNumberCreationCtrl($scope, $mdDialog, themeFactory, dataGen, id)
{
    dataGen.getData($scope, {id: id}, "/sapconfiguration/viewmatnr");

    this.save = function ()
    {
        dataGen.postAsForm({}, {data: $scope.data}, '/sapconfiguration/savematnr').then(function () {
            $mdDialog.hide();
        });
    };

    this.abort = function ()
    {
        $mdDialog.cancel();
    };
}